"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bidder = void 0;
class Bidder {
}
exports.Bidder = Bidder;
//# sourceMappingURL=bidder.js.map